<template>
  <div>
    <h1 class="logintitle">
      <img src="@/assets/login/images/kunlun_logo.png">
    </h1>
    <div class="loginbox">
      <div class="dinglogin-outer-wrap" v-loading="loading">
        <template v-if="accounts.length > 1">
          <div class="dinglogin-content-wrap">
            <h3>选择你的登录账号</h3>
            <h4>如果绑定更多权限账号，请与运营管理员联系。</h4>
            <div class="account-list-wrap">
              <div v-for="userinfo in accounts" :key="userinfo.userid" @click="changeLogin(userinfo.loginCode)" class="account-area">
                <img class="logo" :src="getImageUrl(userinfo.touxiang)" />
                <span>{{ userinfo.username }}</span>
                <img class="arrow" src="@/assets/images/icon-arrow1.png" />
              </div>
            </div>
          </div>
          <a href="/frontend/login" style="color:#333">退出登录 &gt;</a>
        </template>
        <template v-else>
          <div class="dinglogin-content-wrap">
            <h3>系统登录</h3>
            <p>&nbsp;</p>
            <h4>{{ errorMsg || '正在登陆，请稍后...' }}</h4>
            <p>&nbsp;</p>
          </div>
          <a href="/frontend/login#dingtalk" style="color:#333">重新登录 &gt;</a>
        </template>
      </div>
    </div>
    <div class="loginbm">
      <h4>Kunlun Data Information Platform</h4>
      <p>昆仑数据信息平台kunlun.jiemo.net Copyright © 2016-{{ year }} Kunlun.ALL Rights Reserved</p>
    </div>
  </div>
</template>
<script>
import { _post } from '@/utils/http';
import lockr from 'lockr';

export default {
  name: 'DingLogin',
  data() {
    return {
      code: '', // 钉钉扫码登录返回的临时授权code
      errorMsg: '',
      accounts: [], // 管理员列表
      loading: false,
    };
  },
  computed: {
    year() {
      return (new Date()).getFullYear();
    }
  },
  methods: {
    getImageUrl(touxiang) {
      // eslint-disable-next-line
      const defaultAvatar = require('@/assets/images/icon-avatar-default.png');
      return touxiang !== '' ? `${this.$jiemo.imghome}/Upload/teacher/${touxiang}` : defaultAvatar;
    },
    getDingUserList() {
      if (!this.code) {
        this.errorMsg = '钉钉扫码登录参数不存在！';
        return;
      }
      this.loading = true;

      // 获取有效的
      let that = this;
      _post({
        url: '/index/login/getDingUsersByScanCode',
        data: {
          code: this.code,
          site: this.$siteName,
        }
      }).then((res) => {
        this.loading = false;
        if (res.result === 1) {
          that.accounts = res.data;
          if (that.accounts.length === 0) {
            that.errorMsg = '暂时没有绑定任何账号，无法登录。';
          } else if (that.accounts.length === 1) { // 有一个则直接登录
            that.changeLogin(that.accounts[0].loginCode);
          }
        } else {
          that.$message.error(res.msg);
          that.errorMsg = res.msg;
        }
      });
    },
    async changeLogin(loginCode) {
      _post({
        url: '/index/login/dingLoginQintao',
        data: {
          loginCode: loginCode,
          site: 'fib'
        }
      }).then((res) => {
        if (res.result === 1) {
          this.initUserInfo(res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    initUserInfo(login) {
      // this.userinfo = Object.assign({}, this.userinfo, login);
      lockr.set('jwt', login.token);
      window.location = '/frontend/';
    },
  },
  mounted() {
    this.getDingUserList();
  },
  created() {
    // 初始化
    if (this.$route.query.code) {
      this.code = this.$route.query.code;
    }
  },
  beforeCreate() {
    lockr.set('jwt', null);
    lockr.flush();
  }
};
</script>

<style>
body {
  height: 100%;
  background-color: #E9D5CB;
  background-image: url('../assets/login/images/kunlun_loginbg.jpg');
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  overflow: hidden;
}
#app {
  padding-top: 130px;
}
h1 {
  padding-top: 10px!important;
  font-size: 18px;
}
input {
  border: none;
  background: none;
  width: 320px;
  height: 45px;
  border: none;
  line-height: 45px;
  border-radius: 22.5px;
  font-size: 14px;
  padding:0 25px;
  outline: none;
  border: 1px solid #fff;
  background: rgba(255,255,255,.62);
  color: #616161;
  font-family: "微软雅黑", Microsoft Yahei;
  transition: all linear 0.2s;
}
input:-internal-autofill-selected {
  /*内置阴影填充 背景颜色*/
  box-shadow: inset 0 0 0 1000px rgba(255,255,255,.62) !important;
  /*只有谷歌兼容 字体颜色*/
  -webkit-text-fill-color: #616161 !important;
}
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 400px rgba(255,255,255,.62) inset;
  -webkit-text-fill-color: #616161;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-transition-delay: 99999s;
  -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
}
input:focus{
  box-shadow: 0 0 10px rgba(255,255,255,.6);
}
.login-btn {
  background-color: #FFF;
  cursor: pointer;
  color: #333;
  height: 45px;
  width: 320px;
  border: none;
  border-radius: 45px;
  margin-top: 40px;
  font-size: 16px;
  transition: all linear 0.2s;
}
.login-btn:hover{
  box-shadow: 0 0 10px rgba(255,255,255,.6);
}
.logintitle {
  text-align: center;
  color: #fff;
  font-weight: bold;
  font-size: 36px;
  margin-bottom: 40px;
  animation: wobble-vertical 10s linear infinite;
}
.logintitle2 {
  text-align: center;
  color: #fff;
  font-size: 28px;
  font-weight: 200;
  padding: 70px 0;
}
.loginbox {
  width: auto;
  height: 336px;
  margin: auto;
  text-align: center;
  animation: loginmove 1s ease-out 1;
}

.loginbox ul li {
  position: relative;
  display: block;
  width: 384px;
  margin: auto;
  padding: 12px 0;
}
.loginbox ul li span {
  position: absolute;
  right: -200px;
  bottom: 12px;
  display: block;
  width: 211px;
  height: 45px;
  text-align: center;
  line-height: 45px;
  background-color: #fcd71d;
  font-size: 14px;
  color: #383838;
}
.loginbox ul li span:before {
  display: block;
  content: "";
  position: absolute;
  left: -10px;
  top: 50%;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #fcd71d;
  border-left: none;
  margin-top: -10px;
}

.loginbm {
  line-height: 23px;
  margin-top: 120px;
  text-align: center;
  width: 100%;
  color: #fff;
  animation: loginmove 2s ease-out 1;
}
.loginbm h4 {
  color: #fff;
  font-size: 14px;
  font-weight: 200;
}
.loginbm p {
  color: #fff;
  font-size: 12px;
  padding: 0;
  margin: 0;
  opacity: 0.8;
}

.loginbm a {
  font-weight: bold;
  color: #fff;
}

.loginbm a:hover {
  color: #fff;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus textarea:-webkit-autofill,
textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-text-fill-color: #fff;
  transition: background-color 50000s ease-in-out 0s;
}
@-webkit-keyframes wobble-vertical {
  0% {
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
  }
  25% {
    -webkit-transform: translateY(8px);
    transform: translateY(8px);
  }
  50% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
  }
  75% {
    -webkit-transform: translateY(8px);
    transform: translateY(8px);
  }
  100% {
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
  }
}

@keyframes wobble-vertical {
  0% {
    -webkit-transform: translateY(0px);
    -ms-transform: translateY(0px);
    transform: translateY(0px);
  }
  25% {
    -webkit-transform: translateY(8px);
    -ms-transform: translateY(8px);
    transform: translateY(8px);
  }
  50% {
    -webkit-transform: translateY(-8px);
    -ms-transform: translateY(-8px);
    transform: translateY(-8px);
  }
  75% {
    -webkit-transform: translateY(8px);
    -ms-transform: translateY(8px);
    transform: translateY(8px);
  }
  100% {
    -webkit-transform: translateY(0px);
    -ms-transform: translateY(0px);
    transform: translateY(0px);
  }
}
@keyframes loginmove {
  0% {
    opacity: 0;
    -webkit-transform: translateY(50px);
    -ms-transform: translateY(50px);
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    transform: translateY(0);
  }
}
.dinglogin-outer-wrap{
  background:#ffffff;
  display:block;
  width:400px;
  padding:20px 0;
  margin:0 auto;
  border-radius:15px
}
.dinglogin-content-wrap{
  width: 320px;
  margin: 0 auto 30px;
  text-align: left;
}
.dinglogin-content-wrap > h3{
  font-size: 24px;
  line-height: 54px;
  font-weight: bold;
}
.dinglogin-content-wrap > h4{
  font-size: 14px;
  line-height: 16px;
  font-weight: normal;
  color: #888;
  margin-bottom: 30px;
}
.account-list-wrap{
  width: 100%;
  max-height: 206px;
  overflow-y: auto;
  overflow-x: hidden;
}
.account-list-wrap::-webkit-scrollbar {
  width:8px;
}
.account-list-wrap::-webkit-scrollbar-track {
  border-radius:4px;
}
.account-list-wrap::-webkit-scrollbar-thumb {
  border-radius:4px;
  background:rgba(0,0,0,0.1);
}
.account-list-wrap .account-area{
  background: #f2f2f6;
  height: 67.5px;
  line-height: 67.5px;
  margin-bottom: 12px;
  margin-right: 8px;
  padding: 0 10px;
  position: relative;
  border-radius: 8px;
  text-align: left;
  cursor: pointer;
  font-size: 0;
}
.account-list-wrap .account-area:last-of-type{
  margin-bottom: 0;
}
.account-list-wrap .account-area .logo{
  display: inline-block;
  vertical-align: middle;
  width: 48px;
  height: 48px;
  border-radius: 6px;
}
.account-list-wrap .account-area span{
  display: inline-block;
  vertical-align: middle;
  max-width: 72%;
  margin-left: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
}
.account-list-wrap .account-area .arrow{
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-48%);
  width: 16px;
}
</style>
